import React from "react";
import AccountContent from "../../components/account/account-content";
import Header from "../../layout/header";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { BackArrowIcon } from "../../components/ui-elements/svg-icons";
import BadgeImage from "../../components/ui-elements/badge-image";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiGetAccountProfile } from "../../api/account";
import { useNotificationService } from "../../hooks/notification";
import { AccountData, DummyAccountData } from "../../interface/account";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { SkeletonMainAccountLoading } from "../../components/ui-elements/skeleton-loading";
import useResponsive from "../../hooks/useResponsive";

const Account = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const badge = useSelector((state: RootState) => state.content.badge_number);
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const { showNotification } = useNotificationService();

  const { data: accountData, isLoading } = useQuery({
    queryKey: ["account-profile"],
    queryFn: apiGetAccountProfile,
    retry: 1,
    staleTime: 1000 * 60 * 10, // Consider data stale after 5 minutes,
    select: (response) => {
      if (response?.status === "error") {
        if ("details" in response) {
          showNotification(response?.details ?? "An error occurred", "error");
          return DummyAccountData;
        }
        return DummyAccountData;
      }
      if (response?.status === 200) {
        return response?.data as AccountData;
      }
      return DummyAccountData;
    },
  });

  const isSmall = useResponsive("down", "sm", "xl");

  return (
    <>
      {/* Header Menu */}
      <Box
        sx={{
          background: theme.palette.background.paper,
        }}
      >
        <Header scrollContainerId="main-scroll-container">
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <Button onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </Button>
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              {account_profile?.name}
            </Typography>
            <BadgeImage badge={badge} />
          </Stack>
        </Header>
        {isLoading ? (
          <Box
            sx={{
              width: isSmall ? "90%" : 600,
              height: "90vh",
              pt: "6rem",
              mx: "auto",
            }}
          >
            <SkeletonMainAccountLoading />
          </Box>
        ) : (
          <AccountContent account_data={accountData ?? DummyAccountData} />
        )}
      </Box>
    </>
  );
};

export default Account;
